import { render, staticRenderFns } from "./refuse-lead.vue?vue&type=template&id=1345e328&"
import script from "./refuse-lead.vue?vue&type=script&lang=js&"
export * from "./refuse-lead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/refuse-lead.vue
// module id = 1679
// module chunks = 0